<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableList" border style="width: 100%">
                <el-table-column prop="DeviceNo" label="编号" show-overflow-tooltip></el-table-column>
                <el-table-column prop="Name" label="名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="Model" label="型号" show-overflow-tooltip></el-table-column>
                <el-table-column prop="BillWidth" label="票据宽度(mm)" show-overflow-tooltip></el-table-column>
                <el-table-column prop="IsOnline" label="在线情况" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-tag type="success" v-if="scope.row.IsOnline">在线</el-tag>
                        <el-tag type="info" v-else>离线</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="状态" show-overflow-tooltip>
                    <template slot-scope="scope">{{
                        scope.row.State | stateText
                        }}</template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="180px">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button @click="allotPrint(scope.row)" type="text" size="small"
                                v-if="permission.assignPrinter">{{ permission.assignPrinter }}</el-button>
                            <el-button @click="editPrint(scope.row)" type="text" size="small"
                                v-if="permission.editPrinter">{{ permission.editPrinter }}</el-button>
                            <el-button @click="switchTemplate(scope.row)" type="text" size="small"
                                v-if="permission.changeModel">{{ permission.changeModel }}</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog title="分配打印机" :show-close="true" :close-on-click-modal="false" :before-close="closeDialog"
            :visible.sync="visible" width="400px">
            <div class="dialog-content">
                <el-tree ref="tree" :data="treeList" show-checkbox default-expand-all node-key="Id" highlight-current
                    :props="defaultProps" empty-text="暂无数据">
                </el-tree>
                <div class="confirm-button">
                    <el-button size="small" class="search-btn btn-primary" @click="confirmButton">确 定</el-button>
                    <el-button size="small" class="search-btn" @click="closeDialog">取 消</el-button>
                </div>
            </div>
        </el-dialog>
        <el-dialog :close-on-click-modal="false" title="编辑打印机信息" :visible.sync="editVisible" width="800px">
            <div class="dialog-content" v-if="editVisible">
                <printerEdit :PrinterData="printerData" @closeDialog="editClose"></printerEdit>
            </div>
        </el-dialog>
        <el-dialog class="abow_dialog" :visible.sync="assignPrintTempDialog" title="切换模板" width="700px"
            v-show="assignPrintTempDialog" :close-on-click-modal="lockingdilog" :close-on-press-escape="lockingdilog" @close="handleDialogClose">
            <div class="dialogbody">
                <el-tabs type="border-card" @tab-click="switchTemplateTags" v-model="activeTemplateTab">
                    <el-tab-pane :label="label.Label" v-for="label in templateTypeList" :key="label.Value" :name="label.Label">
                        <div class="temp-cont">
                            <div v-for="item in printerTempList" :key="item.Id">
                                <div class="temp-item" v-if="item.ModelType == label.Value">
                                    <div class="preview">
                                        <img class="imgmax" width="160px" height="120px"
                                        :src="downloadUrl + item.ImgUrl + '?imageView2/2/w/160'" />
                                        <a href="#" style="width: 0px;">
                                            <div class="mask">
                                                <h1 class="el-icon-zoom-in"
                                                    v-on:click="viewImageloding(downloadUrl + item.ImgUrl)" />
                                            </div>
                                        </a>
                                    </div>
                                    <div class="temp-info">
                                        <div class="flex">
                                            <div style="margin-right: 10px;">标签尺寸:{{ item.PrintSize }}</div>
                                            <el-radio-group v-model="templateId">
                                                <el-radio :label="item.Id">选择</el-radio>
                                            </el-radio-group>
                                        </div>
                                        <div class="flex">
                                            <el-tag size="mini"
                                                v-if="item.EntpId == ''">通用</el-tag><el-tag
                                                size="mini" type="danger"
                                                v-if="item.EntpId != ''">专用</el-tag><span>{{
                                                item.ModelName
                                                }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="temp-button">
                                <el-button class="search-btn" v-if="templateId !=''" @click="savePrintTemplate">保 存</el-button>
                            </div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </el-dialog>
        <!--查看图片弹窗-->
        <el-dialog title="查看大图" :visible.sync="viewImage" width="700px">
            <div class="imagebody">
                <img width="100%" :src="viewImageSrc" alt="" />
            </div>
        </el-dialog>
    </div>
</template>

<script>
import elTableColumn from "@/components/common/chjtablecolumn";
import breadcrumb from "@/components/common/breadcrumb";
import printerEdit from "@/components/business/msgSetting/printerEdit";
export default {
    name: "",
    components: {
        breadcrumb,
        elTableColumn,
        printerEdit,
    },
    data() {
        let userMsg = this.$util.getLocalStorage("userMsg");
        return {
            editVisible: false,
            visible: false,
            tableList: [], // 表格数据
            treeList: [], // 企业部门树
            defaultProps: {
                // 企业部门树配置项
                children: "Childrens",
                label: "Name",
            },
            currentPid: "", // 当前打印机Id
            checkList: [], // 当前企业部门树选中项
            printerData: {},
            templateTypeList:[{
                Label:"商品标签",
                Value:0
            },{
                Label:"仓位标签",
                Value:1
            },{
                Label:"装箱标签",
                Value:2
            },{
                Label:"员工标签",
                Value:3
            },{
                Label:"箱子标签",
                Value:4
            },{
                Label:"出库外箱标签",
                Value:5
            },{
                Label:"属性标签",
                Value:6
            }],
            assignPrintTempDialog: false,//切换模板弹出
            printerTempList: [],//当前企业打印可用模板
            activeTemplateTab:"商品标签",//用来记录模板标签类型的
            assignPrinterId: "",//打印机id
            viewImage: false,//图片弹窗控件
            viewImageSrc: '',//图片接收
            downloadUrl: this.$util.QN_URL_BASE,
            templateId: "",//当前选中的模板Id
            lockingdilog: false,//弹出层判断
        };
    },
    mounted() {
        this.getTableData();
        this.getEntpPrinterTree();
        let that = this;
        that.permission = that.$util.getPermission('PrinterManage');
    },
    filters: {
        stateText(s) {
            let stu = {
                0: "正常",
                1: "停用",
            };
            return stu[s + ""];
        },
    },
    methods: {
        // 获取表格数据
        getTableData() {
            this.$util
                .axiosGet({
                    url: "/api/EntpInfoManagement/GetEntpPrinterList",
                })
                .then((res) => {
                    let data = res.data;
                    if (!data) data = [];
                    this.tableList = data;
                });
        },
        // 获取企业部门树
        getEntpPrinterTree() {
            this.$util
                .axiosGet({
                    url: "/api/EntpInfoManagement/GetOrgTreeForPrinter"
                })
                .then((res) => {
                    this.treeList = res.data;
                });
        },
        // 分配打印机按钮
        allotPrint(row) {
            this.$util
                .axiosGet({
                    url: "/api/EntpInfoManagement/GetPrinterOrgRs",
                    data: {
                        Pid: row.Id,
                    },
                })
                .then((res) => {
                    this.visible = true;
                    this.currentPid = row.Id;
                    this.checkList = res.data;
                    if (res.data && res.data.length > 0) {
                        this.setKey();
                    }
                });
        },
        //切换模板
        switchTemplate(row) {
            this.assignPrinterId = row.Id;

            this.$util
                .axiosGet({
                    url: "/api/EntpInfoManagement/SwitchTemplate",
                    data: {
                        PrintId: row.Id,
                    },
                })
                .then((res) => {
                    this.printerTempList = res.data;
                    if(res.data){
                        
                        let defSet = this.printerTempList.find(x=> x.ModelType == 0 && x.IsSet)
                        if (defSet) 
                            this.templateId = defSet.Id
                        else
                            this.templateId = ''
                    }
                    this.assignPrintTempDialog = true;

                });
        },
        //保存切换模板
        savePrintTemplate() {
            if(!this.templateId){
                this.$util.warningMsg("请选择模板后再提交！");
                return false;
            }
            this.$util
                .axiosPost({
                    url: "/api/EntpInfoManagement/SavePrintTemplate",
                    data: {
                        Id: this.templateId,
                        PrinterId: this.assignPrinterId,
                    },
                })
                .then((res) => {
                    if (res.errcode === 0) {
                        this.assignPrintTempDialog = false;
                        this.$util.successMsg("分配成功");
                        this.getTableData();
                    }
                });
        },
        switchTemplateTags(tab, event){
            let index = parseInt(tab.index);
            this.activeTemplateTab = this.templateTypeList[index].Label;
            let set = this.printerTempList.find(x=>x.ModelType == index && x.IsSet)
            if (set) {
                this.templateId = set.Id
            }else{
                this.templateId = ''
            }
        },
        handleDialogClose() {
            this.activeTemplateTab = this.templateTypeList[0].Label;
        },
        //查看图片弹窗
        viewImageloding(url) {
            this.viewImage = true;
            this.viewImageSrc = url;
        },
        // 设置选中节点
        setKey() {
            this.$nextTick(() => {
                this.$refs.tree.setCheckedKeys(this.checkList);
            });
        },
        // 保存修改项
        confirmButton() {
            let keysArr = this.$refs.tree.getCheckedKeys();
            this.$util
                .axiosPost({
                    url: "/api/EntpInfoManagement/AssignPrinter",
                    data: {
                        Pid: this.currentPid,
                        OrgIds: keysArr,
                    },
                    hideLoading: true,
                })
                .then((res) => {
                    if (res.errcode === 0) {
                        this.visible = false;
                        this.$util.successMsg("分配成功");
                        this.getTableData();
                    }
                });
        },
        closeDialog() {
            this.currentPid = "";
            this.checkList = [];
            this.visible = false;
        },
        editPrint(row) {
            if (row) {
                this.printerData = row;
                this.editVisible = true;
            } else this.$util.warningMsg("可能未真正选中，请重新操作");
        },
        editClose() {
            this.editVisible = false;
            this.getTableData();
        },

    },
};
</script>

<style lang="less" scoped>
.table-ctn {
    margin-top: 24px;
}

.imagebody {
    padding-top: 20px;
    padding-bottom: 10px;
}

.dialogbody {
    min-height: 220px;
    max-height: 640px;
    padding-top: 20px;
    padding-bottom: 20px;
}

.temp-cont {
    width: 680px;
    min-height: 220px;
    max-height: 535px;
    overflow: auto;
    display: flex;
    flex-wrap: wrap;
}
.temp-item{
    width: 33%;
    margin: 10px 20px;
}
.temp-info{
    width: 180px;
    div{
        min-height: 30px;
        display: flex;
        align-items: center;
    }
}
.temp-button{
    width: 93%;
    height: 40px;
    display: flex;
    justify-content: end;
}
.preview {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 160px;
    height: 140px;
    position: relative;
    background: #d5d5d5;
    border: 1px solid #ecf8ff;
    border-radius: 10px;
    align-items: center;
    text-align: center;
    overflow: hidden;
}

.imgmax {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    position: absolute;
}

.mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 160px;
    height: 140px;
    background: rgba(101, 101, 101, 0.6);
    color: #ffffff;
    font-size: 20px;
    opacity: 0;
}

.preview a:hover .mask {
    opacity: 1;
}

.mask h1 {
    margin-top: 50px;
}

.confirm-button {
    text-align: right;
    margin-top: 20px;
}
</style>
